/** @format */

import React, { FC, useState, useEffect, useMemo } from 'react'
import { _$, Dialog, Table, TableColumn, Button, Tooltip } from 'kpc-react'
import styled from 'styled-components'
import { TabsListProps } from './constants'
import API from 'src/api/ApiAlarmHistory'
import useFormTable from 'src/hooks/useFormTable'
import { TablePage } from 'src/components'
import { LabelValueItem } from 'src/utils/interface'

const AlarmEventList: FC<TabsListProps> = ({
  className,
  region,
  dateTime,
  query,
  policyName,
  eventProductList
}) => {
  const [productList, setProductList] = useState<LabelValueItem<string, any>[]>([])
  const [tableGroup, setTableGroup] = useState({
    productName: 999
  })
  const [receiversVisible, setReceiversVisible] = useState<boolean>(false)
  const [receiversData, setReceiversData] = useState([])
  const [callbackVisible, setCallbackVisible] = useState<boolean>(false)
  const [callbackData, setCallbackData] = useState([])
  const { run, result, pageState, loading, total } = useFormTable(
    API.getEventHistoryList,
    {
      params: {
        ProductType: tableGroup.productName,
        StartTime: dateTime.StartTime,
        EndTime: dateTime.EndTime,
        Region: region,
        InstanceId: query,
        PolicyName: policyName || ''
      },
      manual: true
    },
    data => {
      const { alertList, totalCount } = data
      if (Array.isArray(alertList)) {
        return { tableData: alertList || [], totalCount: totalCount || 0 }
      } else {
        return { tableData: [], totalCount: 0 }
      }
    }
  )

  useEffect(() => {
    const productGroup = [{ label: _$('全部'), value: 999 }]
    if (Array.isArray(eventProductList)) {
      const group = eventProductList.map(item => {
        return { label: item.label, value: item.value }
      })
      setProductList([...productGroup, ...group])
    } else {
      setProductList(productGroup)
    }
  }, [eventProductList])

  useEffect(() => {
    if (dateTime?.StartTime && dateTime?.EndTime && region) {
      run({
        StartTime: dateTime.StartTime,
        EndTime: dateTime.EndTime,
        Region: region,
        ProductType: tableGroup.productName || 999,
        InstanceId: query,
        PolicyName: policyName || ''
      })
    }
  }, [dateTime.StartTime, dateTime.EndTime, region, query])

  const tableScheme = useMemo(() => {
    return {
      policyName: _$('策略名称'),
      productName: {
        title: _$('产品类型'),
        group: policyName ? undefined : productList
      },
      eventTitle: _$('告警规则'),
      instanceId: {
        title: _$('关联资源'),
        template: item => (
          <>
            <Tooltip content={`${item.instanceName} (${item.instanceId})`}>
              <span>{item.instanceName}</span>
            </Tooltip>
          </>
        )
      },
      triggerTime: _$('时间'),
      alarmReceivers: {
        title: _$('告警接收人'),
        template: ({ alarmReceivers, callBackUrl }) => (
          <div className="ksc-space">
            {alarmReceivers?.length ? (
              <a
                className="primary-color"
                onClick={() => {
                  setReceiversData(alarmReceivers || [])
                  setReceiversVisible(true)
                }}
              >
                {_$('联系人')}
              </a>
            ) : null}
            {callBackUrl?.length ? (
              <a
                className="primary-color"
                onClick={() => {
                  setCallbackData(callBackUrl?.split(',') || [])
                  setCallbackVisible(true)
                }}
              >
                {_$('回调')}
              </a>
            ) : null}
          </div>
        )
      }
    }
  }, [result])

  return (
    <div className={className}>
      <TablePage
        tableProps={{
          scheme: tableScheme,
          data: result,
          checkType: 'none',
          resizable: true,
          group: tableGroup,
          'on$change-group': (_c, value) => {
            setTableGroup(value)
            run({
              PageIndex: 1,
              ProductType: value.productName,
              PolicyName: policyName
            })
          }
        }}
        pageProps={{ total, ...pageState }}
        loading={loading}
        run={run}
      />
      <Dialog
        value={receiversVisible}
        onClose={() => {
          setReceiversVisible(false)
        }}
        title={_$('告警联系人')}
        b-footer={
          <React.Fragment>
            <Button type="primary" onClick={() => setReceiversVisible(false)}>
              {_$('关闭')}
            </Button>
          </React.Fragment>
        }
      >
        <Table scheme={{}} data={receiversData} checkType="none" resizable={true}>
          <TableColumn key="name" title={_$('姓名')} />
          <TableColumn key="email" title={_$('邮箱')} />
          <TableColumn key="phone" title={_$('电话')} />
        </Table>
      </Dialog>
      <Dialog
        value={callbackVisible}
        onClose={() => {
          setCallbackVisible(false)
        }}
        title={_$('告警回调')}
        b-footer={
          <React.Fragment>
            <Button type="primary" onClick={() => setCallbackVisible(false)}>
              {_$('关闭')}
            </Button>
          </React.Fragment>
        }
      >
        {callbackData?.length &&
          callbackData.map(item => (
            <p style={{ fontSize: 14 }} key={item}>
              {item}
            </p>
          ))}
      </Dialog>
    </div>
  )
}

export default styled(AlarmEventList)`
  .header {
    display: flex;
    justify-content: space-between;
  }
`
